import React, { useEffect, useState } from "react";
import {
    Table,
    Empty,
    Tooltip,
    Col,
    Row,
} from "antd";
import {
    BarsOutlined,
} from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";
import { ColumnHelper } from "util/TableHelper";
import FirmTransactionTableFilter from "../Filters/FirmTransactionTableFilter "
import config from "../../util/ApiforContext";
import moment from "moment";
const FirmTransactionList = (props) => {
    const [totalFirmTransaction, setTotalFirmTransaction] = useState();
    const [tableData, setTableData] = useState({
        data: [],
        total: 0,
        loading: false,
    });
    const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
        skip: 0,
        take: 200,
        current: 1,
        filter: "",
    });

    const getTableData = (result) => {
        setTableData({
            ...tableData,
            loading: true,
        });
        let req = {
            tenantId: localStorage.getItem("tenantId"),
            startDate: result.startDate,
            endDate: result.endDate,
            firmBranchNumber: result.firmBranchNumber,
        }
        RequestHandler.post(`/FirmTransaction`, req).then((response) => {
            if (Array.isArray(response.data)) {
                setTableData({
                    data: response.data,
                    total: response.data.length,
                    loading: false,
                });
                const InAmount = new Intl.NumberFormat('tr-TR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(response.data.reduce((sum, item) => sum + (item.debit || 0), 0).toFixed(2));
                const OutAmount = new Intl.NumberFormat('tr-TR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }).format(response.data.reduce((sum, item) => sum + (item.credit || 0), 0).toFixed(2));
                setTotalFirmTransaction({
                    count: response.data.length,
                    amountInPayment: InAmount,
                    amountOutPayment: OutAmount
                });
            }
        });
    };
    const paging = (p, _, sorter) => {
        setTableDataQueryOptions((prevState) => {
            return {
                ...prevState,
                skip: (p.current - 1) * prevState.take,
                take: p.pageSize,
                current: p.current,
            };
        });
    };
    const columns = [
        {
            title: "Tarih",
            dataIndex: "date",
            render: (data) => moment(data).format("DD.MM.YYYY"),
        },
        {
            title: "Borç",
            dataIndex: "credit",
            render: ColumnHelper.renderDecimal,
        },
        {
            title: "Alacak",
            dataIndex: "debit",
            render: ColumnHelper.renderDecimal,
        },
        {
            title: "Bakiye",
            dataIndex: "balance",
            render: ColumnHelper.renderDecimal,
        },
        {
            title: "Fiş No",
            dataIndex: "documentNumber"
        },
        {
            title: "Fiş Türü",
            dataIndex: "documentType",
        },
        {
            title: "Referans Numarası",
            dataIndex: "referenceNumber"
        },
        {
            title: "Açıklama",
            dataIndex: "explanation",
        },
    ];
    const onClearTableFilter = () => {
        setTableData({
            data: [],
            loading: false,
        });
    };

    const onFinishTableFilter = (result) => {
        getTableData(result)
    };
    return (
        <>
            <Row>
                <Col xs={24} md={12} lg={14}>
                    <p style={{ fontSize: "120%", marginTop: -5 }}>
                        <BarsOutlined /> CARİ HESAPLARI
                    </p>
                </Col>
                <Col xs={24} md={12} lg={10} style={{ textAlign: "right" }}>
                    <span style={{ marginRight: 50, fontSize: 16 }}>
                        Adet: {totalFirmTransaction?.count}
                    </span>
                    <span style={{ marginRight: 50, fontSize: 16 }}>
                        Toplam Alacak: {totalFirmTransaction?.amountInPayment} ₺
                    </span>
                    <span style={{ marginRight: 50, fontSize: 16 }}>
                        Toplam Borç: {totalFirmTransaction?.amountOutPayment} ₺
                    </span>
                </Col>
            </Row>
            <FirmTransactionTableFilter
                onClearFilter={onClearTableFilter}
                onFinishFilter={onFinishTableFilter}
                style={{ marginTop: 12, marginBottom: 12 }}
            />
            <Row id="tableArea">
                <Col span={24}>
                    <Table
                        columns={columns}
                        locale={{
                            emptyText: (
                                <Empty
                                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                                    description="Veri Yok"
                                />
                            ),
                        }}
                        style={{ overflowX: "auto", maxHeight: "100%" }}
                        rowKey="id"
                        filterable={true}
                        size="small"
                        sortable={true}
                        pageable={true}
                        onChange={paging}
                        pagination={{
                            defaultPageSize: 200,
                            pageSizeOptions: ["15", "25", "50", "100", "200"],
                            total: tableData.total,
                            current: tableDataQueryOptions.current,
                        }}
                        dataSource={tableData.data}
                        loading={tableData.loading}
                    />
                </Col>
            </Row>
        </>
    );
};
export default FirmTransactionList;